// Shared finance-module navigation used by the collapsible finance side menu
// (FinanceNav). Groups mirror the Finance dashboard sections.
export const FINANCE_NAV = [
  {
    title: 'General Ledger',
    color: '#37474f',
    items: [
      { label: 'Chart of Accounts', path: '/gl-accounts' },
      { label: 'General Journal', path: '/finance/general-journal' },
      { label: 'Trial Balance', path: '/finance/trial-balance' },
      { label: 'Find Entries', path: '/finance/find-entries' },
      { label: 'Income Statement', path: '/finance/income-statement' },
      { label: 'Balance Sheet', path: '/finance/balance-sheet' },
      { label: 'Cash Flow', path: '/finance/cash-flow' },
      { label: 'GL by Dimension', path: '/finance/gl-by-dimension' },
      { label: 'P&L by Dimension', path: '/finance/pnl-by-dimension' },
      { label: 'VAT Return', path: '/finance/vat-return' },
      { label: 'Withholding Tax', path: '/finance/wht' },
      { label: 'Budget Entry', path: '/finance/budgets' },
      { label: 'Budget vs Actual', path: '/finance/budget-vs-actual' },
    ],
  },
  {
    title: 'Receivables',
    color: '#1565c0',
    items: [
      { label: 'Learners / Customers', path: '/learners' },
      { label: 'Student Invoices', path: '/invoices' },
      { label: 'Payments Received', path: '/receipts' },
      { label: 'Batch Receipts', path: '/finance/batch-receipts' },
      { label: 'Statements', path: '/statements' },
      { label: 'Balances / Debtors', path: '/finance/balances' },
      { label: 'Aged Receivables', path: '/finance/aged-receivables' },
      { label: 'Credit Notes', path: '/finance/credit-notes' },
      { label: 'Daily Collections', path: '/finance/collections' },
      { label: 'Fee Structures', path: '/feestructures' },
      { label: 'Charge Items', path: '/academics/charge-items' },
    ],
  },
  {
    title: 'Payables',
    color: '#e65100',
    items: [
      { label: 'Vendors / Suppliers', path: '/suppliers' },
      // Procurement flow order: Quote → Order → Invoice → Payment
      { label: 'Purchase Quotes', path: '/payables/quotes' },
      { label: 'Purchase Orders', path: '/payables/orders' },
      { label: 'Purchase Invoices', path: '/payables/invoices' },
      { label: 'Payment Vouchers', path: '/payables/vouchers' },
      { label: 'Vendor Credit Notes', path: '/payables/credit-notes' },
      { label: 'Aged Payables', path: '/payables/aging' },
    ],
  },
  {
    title: 'Banks & Cash',
    color: '#00838f',
    items: [
      { label: 'Bank Accounts', path: '/banks' },
      { label: 'Bank Reconciliation', path: '/finance/bank-reconciliation' },
    ],
  },
  {
    title: 'Fixed Assets',
    color: '#6a1b9a',
    items: [
      { label: 'Fixed Assets', path: '/fixed-assets' },
      { label: 'FA Classes', path: '/fixed-assets/classes' },
      { label: 'FA Posting Groups', path: '/fixed-assets/posting-groups' },
    ],
  },
  {
    title: 'Stores & Inventory',
    color: '#2e7d32',
    items: [
      { label: 'Items & Services', path: '/payables/items' },
      { label: 'Locations', path: '/setups/locations' },
      { label: 'Store Requisitions', path: '/payables/requisitions' },
      { label: 'Transfer Orders', path: '/procurement/transfers' },
      { label: 'Item Journals', path: '/payables/item-journals' },
    ],
  },
  {
    title: 'Setups',
    color: '#455a64',
    items: [
      { label: 'Posting Setup', path: '/setups/posting' },
      { label: 'Posting Groups', path: '/setups/posting-groups' },
      { label: 'Posting Period Lock', path: '/setups/posting-period' },
      { label: 'Year-End Close', path: '/finance/year-end-close' },
      { label: 'Dimensions', path: '/setups/dimensions' },
      { label: 'Number Series', path: '/setups/number-series' },
      { label: 'Email / SMTP Setup', path: '/setups/mail' },
      { label: 'VAT Posting Groups', path: '/setups/vat-posting-groups' },
    ],
  },
];

// Prefixes that identify a finance-module page (so the side menu shows there).
const FINANCE_PREFIXES = [
  '/finance', '/payables', '/setups', '/fixed-assets', '/procurement',
  '/gl-accounts', '/banks', '/suppliers', '/ledger',
  '/invoices', '/receipts', '/statements', '/feestructures', '/billing', '/payments',
];

// True when the current path belongs to the finance module (but not the finance
// home dashboard itself, which already shows the full grid).
export const isFinancePath = (pathname) => {
  if (!pathname || pathname === '/finance') return false;
  return FINANCE_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'));
};
